import { useTheme } from '@emotion/react';
import { CircularProgress, Dialog, DialogContent, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { shopDetails } from '../../../redux/Account/ShopDetails/action';
import { configDetails } from '../../../redux/Account/action';
import SuccessMessageModal from '../../Common/SuccessMessage';
import ShopPricing from '../ShopDetails/ShopPricing';
import InvoiceNumberSettings from './InvoiceNumberSettings';
import PartRelatedFees from './PartRelatedFees';
import PartsSettings from './PartsSettings';

const InventorySettings = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    // Fetch shop details on component mount
    useEffect(() => {
        getShopDetails();
        fetchConfig();
    }, []);

    /**
     * Fetches shop details APIS from the server via Redux action
     */
    const getShopDetails = async () => {
        await dispatch(shopDetails());
    };

    const fetchConfig = async () => {
        await dispatch(configDetails());
    };

    return (
        <>
            <PartsSettings
                fetchConfig={fetchConfig}
                setShowLoader={setShowLoader}
                setOpenSuccessModal={setOpenSuccessModal}
                setSuccessMessage={setSuccessMessage}
            />
            <InvoiceNumberSettings setShowLoader={setShowLoader} setOpenSuccessModal={setOpenSuccessModal} setSuccessMessage={setSuccessMessage} />
            <ShopPricing setShowLoader={setShowLoader} setOpenSuccessModal={setOpenSuccessModal} setSuccessMessage={setSuccessMessage} />

            <PartRelatedFees getShopDetails={getShopDetails} type="part" />

            <Dialog fullScreen={false} open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
        </>
    );
};

export default InventorySettings;
